import { Add } from '@mui/icons-material';
import { Skeleton } from '@mui/material';
import clsx from 'clsx';
import { DateTime } from 'luxon';

import { ButtonIcons } from '@/components/ButtonIcons';

import { DAY_NAMES } from './config';

import s from './TaskTable.module.scss';

export const renderSkeletonColumn = (dayIndex: number, currentDate: DateTime) => {
  const today = DateTime.local();
  const dayDate = currentDate.startOf('week').plus({ days: dayIndex });
  const isToday = dayDate.hasSame(today, 'day');
  const isWeekend = [6, 7].includes(dayDate.weekday);
  const skeletonCount = ((dayIndex * 17) % 4) + 2;

  return (
    <div
      key={dayIndex}
      className={clsx(s.task_table__column, {
        [s.weekend]: isWeekend,
        [s['today__wrapper']]: isToday,
      })}
    >
      <div
        className={clsx(s['task_table__column-title'], {
          [s['weekend__column-title']]: isWeekend,
          [s['today__column-title']]: isToday,
        })}
      >
        <div
          className={clsx(s['task_table__column-title-day'], {
            [s['today__column-title-day']]: isToday,
          })}
        >
          <h2>{DAY_NAMES[dayIndex]}</h2>
          <p>{dayDate.day}</p>
        </div>
        <div className={s['task_table__column-title-action']}>
          <Skeleton width={30} height={25} animation="wave" />
          <ButtonIcons isAccentColor={isToday}>
            <Add />
          </ButtonIcons>
        </div>
      </div>
      <div className={s['task_table__column-body']}>
        {[...Array(skeletonCount)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            height={64}
            animation="wave"
            style={{ borderRadius: 8, marginBottom: '5px' }}
          />
        ))}
      </div>
    </div>
  );
};
